module.exports = __webpack_public_path__ + "static/media/image_75.643cc3fc.png";